import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

	static targets = [ 'item' ]

	static values = {
		orderInputSelector:  { type: String, default: '.update-order-attribute' }
	}

	connect() {
		this.updateItemOrder()
		this.connected = true
	}

	itemTargetConnected() {
		if (this.connected) { this.updateItemOrder() }
	}

	itemTargetDisconnected() {
		if (this.connected) { this.updateItemOrder() }
	}

	updateItemOrder(_event) {
		if (!this.hasItemTarget) { return false }

		let orderValue = 1
		this.itemTargets.forEach( (item) => {
			if (item.classList.contains('d-none')) { return }

			const orderInput = item.querySelector(this.orderInputSelectorValue)
			orderInput.value = orderValue
			orderValue += 1
		})
	}

}
